var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsAmplify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/64/Arch_AWS-Amplify_64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/64/Arch_AWS-Amplify_64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/64/Mobile",
    fill: "#DD344C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.6107389,59.179 L39.5067389,20 L45.2577389,20 L65.3627389,59.179 L59.6107389,59.179 Z M67.8887389,59.722 L46.7587389,18.544 C46.5887389,18.21 46.2447389,18 45.8697389,18 L37.8697389,18 C37.5207389,18 37.1977389,18.181 37.0157389,18.479 C36.8347389,18.776 36.8207389,19.147 36.9797389,19.457 L58.1097389,60.636 C58.2807389,60.969 58.6247389,61.179 58.9997389,61.179 L66.9997389,61.179 C67.3477389,61.179 67.6717389,60.998 67.8527389,60.7 C68.0347389,60.403 68.0487389,60.033 67.8887389,59.722 L67.8887389,59.722 Z M47.5987389,59.179 L32.2147389,30.332 L35.3657389,25.121 L53.3407389,59.179 L47.5987389,59.179 Z M36.3097389,22.624 C36.1407389,22.305 35.8147389,22.101 35.4547389,22.091 C35.1087389,22.07 34.7567389,22.265 34.5697389,22.573 L30.2097389,29.784 C30.0267389,30.086 30.0167389,30.461 30.1817389,30.772 L46.1167389,60.65 C46.2907389,60.975 46.6307389,61.179 46.9997389,61.179 L54.9997389,61.179 C55.3497389,61.179 55.6747389,60.995 55.8557389,60.695 C56.0367389,60.395 56.0477389,60.022 55.8837389,59.712 L36.3097389,22.624 Z M14.7727389,59.179 L28.8847389,35.84 L31.7597389,41.229 L25.1337389,52.678 C24.9547389,52.988 24.9547389,53.369 25.1327389,53.679 C25.3117389,53.988 25.6417389,54.179 25.9997389,54.179 L38.6667389,54.179 L41.3327389,59.179 L14.7727389,59.179 Z M40.1487389,52.708 C39.9747389,52.383 39.6347389,52.179 39.2657389,52.179 L27.7337389,52.179 L33.7687389,41.75 C33.9427389,41.451 33.9487389,41.084 33.7867389,40.779 L29.8227389,33.346 C29.6527389,33.029 29.3267389,32.827 28.9667389,32.817 C28.5827389,32.8 28.2697389,32.992 28.0847389,33.299 L12.1437389,59.661 C11.9577389,59.971 11.9517389,60.356 12.1287389,60.67 C12.3057389,60.985 12.6377389,61.179 12.9997389,61.179 L42.9997389,61.179 C43.3507389,61.179 43.6757389,60.995 43.8567389,60.694 C44.0377389,60.392 44.0477389,60.018 43.8817389,59.708 L40.1487389,52.708 Z",
    id: "AWS-Amplify_Icon_64_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsAmplify);
export default __webpack_public_path__ + "static/media/aws-amplify.443f17a0cc06c8df77f937de81b920d2.svg";
export { ForwardRef as ReactComponent };